module.exports = __webpack_public_path__ + "static/img/class_sm_1.609c67af.jpg";